export default __webpack_public_path__ + "static/media/soundcloud.8c262542.svg";